import api from './client';
import type {
  ApiResponse,
  RecordEventPayload,
  FetchEventsParams,
  FetchSummaryParams,
  CreateDefinitionPayload,
  UpdateDefinitionPayload,
  UpdateSettingsPayload,
  AnalyticsEvent,
  AnalyticsSummary,
  AnalyticsDefinition,
  AnalyticsSettings,
} from '../types/systemTypes';

export async function recordAnalyticsEvent(payload: RecordEventPayload): Promise<ApiResponse> {
  const response = await api.post('/analytics/events', payload);
  return response.data;
}

export async function fetchAnalyticsEvents(params: FetchEventsParams = {}): Promise<ApiResponse<AnalyticsEvent[]>> {
  const response = await api.get('/analytics/events', { params });
  return response.data;
}

export async function fetchDailySummary(params: FetchSummaryParams = {}): Promise<ApiResponse<AnalyticsSummary[]>> {
  const response = await api.get('/analytics/summary/daily', { params });
  return response.data;
}

export async function getAnalyticsDefinitions(includeDisabled: boolean = true): Promise<ApiResponse<AnalyticsDefinition[]>> {
  const response = await api.get('/analytics/definitions', {
    params: { includeDisabled }
  });
  return response.data;
}

export async function createAnalyticsDefinition(payload: CreateDefinitionPayload): Promise<ApiResponse<AnalyticsDefinition>> {
  const response = await api.post('/analytics/definitions', payload);
  return response.data;
}

export async function updateAnalyticsDefinition(id: number, payload: UpdateDefinitionPayload): Promise<ApiResponse<AnalyticsDefinition>> {
  const response = await api.patch(`/analytics/definitions/${id}`, payload);
  return response.data;
}

export async function getAnalyticsSettings(): Promise<ApiResponse<AnalyticsSettings>> {
  const response = await api.get('/analytics/settings');
  return response.data;
}

export async function updateAnalyticsSettings(payload: UpdateSettingsPayload): Promise<ApiResponse<AnalyticsSettings>> {
  const response = await api.put('/analytics/settings', payload);
  return response.data;
}

export async function backfillUserIdForSession(sessionId: string): Promise<ApiResponse> {
  const response = await api.post('/analytics/events/backfill-session', { sessionId });
  return response.data;
}
